<template>
  <div
    @click="$store.commit('modals/OPEN_REPORT_POPUP', false)"
    class="py-3 md-pd d-flex align-items-center w-100 h-100 justify-content-center skill-report__background"
  >
    <section
      @click.stop
      class="w-60 p-2 skill-report position-relative"
      :class="`light-theme`"
    >
      <div
        @click="$store.commit('modals/OPEN_REPORT_POPUP', false)"
        class="d-flex position-absolute align-items-center justify-content-center cross-icon cursor-pointer"
        :class="`cross-icon-light`"
      >
        X
      </div>
      <iframe
        class="w-100 h-100"
        :src="reportUrl"
        type="application/pdf"
      ></iframe>
    </section>
  </div>
</template>
<script>
export default {
  name: "SkillReportModal",
  computed: {
    reportUrl() {
      return this.$store.state.user.reportUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";

.light-theme {
  background: #fff;

  .text {
    color: #1c1c1e;
  }
}

.dark-theme {
  background: #121215;

  .text {
    color: #fff;
  }

  .main-text {
    color: #8e8e93;
  }
}

.cross-icon {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  top: 0;
  font-size: 1.25em;
  padding: 0.5em;
  border-radius: 50%;
  height: 2em;
  width: 2em;
  top: -0.5em;
  right: -0.5em;
  transition: all 0.23s ease 0.1s;
  transform: translate(8px, -2px);
  &-dark {
    background: #1c1c1e;
  }

  &-light {
    background: #fffffffa;
  }
  // For hover effect of close btn
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    outline: none;
    transform: translate(5px, 3px);
    box-shadow: none;
  }
}

.skill-report {
  width: 95%;
  height: 100%;
  border-radius: 10px;

  &__background {
    background: #0000006a;
    backdrop-filter: blur(5px);
    position: fixed !important;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1070;
    width: 100%;
    height: 100%;
  }

  &__heading {
    &--1 {
      font-size: 1.75em;
    }
  }
}

@media only screen and (max-width: 1024px) {
  .skill-report {
    width: 60%;
  }
}

@media only screen and (max-width: 991px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .skill-report {
    width: 75%;
  }
}

@media only screen and (max-width: 660px) {
  .skill-report {
    width: 90%;
    &__heading {
      &--1 {
        font-size: 1.5em;
      }
    }
  }
}
</style>
